export const AlliedFacultyActions = {
  GET_ALLIED_FACULTY: "GET_ALLIED_FACULTY",
  SET_ALLIED_FACULTY: "SET_ALLIED_FACULTY",
};
